import {  AuthType, init } from "@thoughtspot/visual-embed-sdk";
import { callOperation } from "async-ops";
import { GET_THOUGHT_SPOT_SETTINGS } from "../common_widgets/navigation_bar/services/get-thought-spot-settings";

let spotURL = "";
if (window.location.origin.includes("localhost")) {
  spotURL =
    "https://ts-mdae.mdauditenterprise.com/images/ui-rewrite-icons/menuicons/aiassistant.svg";
} else {
  spotURL =
    window.location.origin +
    "/images/ui-rewrite-icons/menuicons/aiassistant.svg";
}

const TsInitSdk: () => void = () => {    
    callOperation(GET_THOUGHT_SPOT_SETTINGS)
    .then((response) => {

        if(!response) {
            throw Error("Cannot retrieve thoughtspot settings");
        }

        if (!response.baseUrl || response.baseUrl === "") {
            throw Error('Thoughtspot base url does not exist');
        }

        init({
            thoughtSpotHost: response.baseUrl,
            authType: AuthType.None,
            customizations: {
                style: {
                        customCSS: {
                            rules_UNSTABLE: {
                                // hide KPI watchlist in the home page
                                '[class="home-container-module__homepageCarouselContainer"]':{  
                                    "display":"none",
                                },
                                 // hide the sage search image in the home page after TS 9.6 upgrade
                                '[class="eureka-search-bar-module__homeSearchBarImg"]':{
                                    "display":"none"
                                },
                                // hide the sage search text in the home page after TS 9.6 upgrade
                                'h2.typography-module__h2.typography-module__base.eureka-search-bar-module__searchBarTitle.typography-module__whiteSpace':{
                                    "visibility":"hidden"
                                },
                                // Thin out the search bar module 
                                '.eureka-search-bar-module__emptySeedQuestions':{
                                    "height": "120px"
                                },
                                // Replace the background color of the search bar module to grey
                                '.eureka-search-bar-module__searchBarWrapper':{
                                    "background-color": "#dbdfe7db"
                                },
                                // hide sage text in search bar after TS 10.3 upgrade
                                '[data-testid="homepage-searchbar-module-title"]':{
                                    "display":"none"
                                },
                                // hide the "Ask sage" button text in the home page after TS 10.3 upgrade
                                '[data-testid="eureka-go-btn"] [class="typography-module__body-normal typography-module__white button-module__buttonText button-module__iconLeft button-module__truncateText typography-module__whiteSpace"]':{
                                    "display":"none"
                                },
                                // hide "Sage" from home page footer text
                                'p.typography-module__footnote.typography-module__grayLight.typography-module__whiteSpace':{
                                    "visibility":"hidden"
                                },
                                'p.typography-module__footnote.typography-module__grayLight.typography-module__whiteSpace::after':{
                                    "visibility":"visible",
                                    "display":"block",
                                    "content":"\"Answers may contain errors and should be verified\"",
                                    "position":"relative",
                                    "top":"-10px",
                                },
                                //Hide preview button
                                '[class="button-module__buttonWrapper chat-input-module__previewButton"]': {
                                    display: "none",
                                  },
                                  //hide icon near worksheet
                                '[class="icon-module__iconStyle icon-module__m icon-module__black"]': {  
                                display: "none",
                                } ,
                                // hide the "Timestamp" near spotter
                                '[class="avatars-module__timestamp"]': {
                                display: "none",
                                }, 
                                //Hide TS logo in pinboard edit mode
                                '[class="pinboard-edit-header-module__headerLogo"]': {
                                display: "none",
                                },                                                      
                            },
                        }
                     },
                     content:{
                        strings:{
                          "Spotter":"AI Assist"
                        }
                      },
                     iconSpriteUrl: spotURL,
                  },                  
            });            
    })
    .catch( error => { console.error(error.message); });    
};
export default TsInitSdk;